import { createRouter, createWebHistory } from 'vue-router'
import _ from 'lodash'
import renderMetaTag from '../utils/renderMetaTag';
import routes from "@/router/routes";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

router.beforeEach(function(to, from, next) {
  const title = _.get(to, 'meta.title', null);
  const metaTags = _.get(to, 'meta.metaTags', null);

  if(title){
    document.title = title;
  }

  if(metaTags){
    metaTags.forEach(tag => renderMetaTag(tag));
  }

  next();
});

export default router;
